import { render, staticRenderFns } from "./FormCustomerFeature.vue?vue&type=template&id=28706b79&"
import script from "./FormCustomerFeature.vue?vue&type=script&lang=js&"
export * from "./FormCustomerFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports